export const GROUP = "/management/group/:id?";
export const AGENCY = "/management/agency/:id?";
export const TEAM = "/management/team/:id?";
export const USER = "/management/user/:id?";
export const PROFILE = "/profile";
export const BILLING = "/billing";
export const STATS = "/stats";
export const INFOTHEQUE = "/infotheque";
export const MANAGEMENT_OLD = "/management_old";
export const MANAGEMENT = "/management";
export const OFFER = "/offer";
